export default "<ion-app style=\"background: none transparent !important;\">\n  <ion-router-outlet [swipeGesture]=\"false\"></ion-router-outlet>\n</ion-app>\n";